import React from 'react';
import EmeraldGardenWebsite from './pages/Home';

const App = () => {
  return (
    <div className="App">
      <EmeraldGardenWebsite />
    </div>
  );
}

export default App;